import { render, staticRenderFns } from "./delete-from-devices.vue?vue&type=template&id=c648b080&"
import script from "./delete-from-devices.vue?vue&type=script&lang=js&"
export * from "./delete-from-devices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports